import type { ResourceProps } from '@refinedev/core'
import { i18n } from '../../shared/i18n'

export const productManagementResources: ResourceProps[] = [
  {
    name: 'product-management',
    meta: {
      label: i18n.t('navigation.productManagement.label'),
    },
  },
  {
    name: 'product-list',
    list: '/products',
    show: '/products/:id',
    create: '/products/create',
    edit: '/products/:id/edit',
    meta: {
      label: i18n.t('navigation.productManagement.productList'),
      parent: 'product-management',
    },
  },
]
